import { useEffect, useState } from "react";
import { Button, Container, Grid, Paper, Typography, useTheme } from "@mui/material";
import CustomBreadcrumbs from "../../../../../components/breadcrumbs";
import SectionTitle from "../../../../../components/sectionTitle";

import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { deleteModifierOption, getModifierOptions } from "../../../../../controllers/company/products/ModifierOptionsController";
import ModifierGroupOptionsDataTable from "./dataTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import QUDProgress from "../../../../../components/progress";

export default function ModifierGroupOptions()
{
    const theme = useTheme();
    const [attribute,setAttribute] = useState({});
    const [attributeValues,setAttributeValues] = useState([]);
    
    const [isLoading,setIsLoading] = useState(false);
    const [modifierGroup,setModifierGroup] = useState({});
    const [modifiers,setModifiers] = useState([]);

    const history = useHistory();
    const { modifierGroupId } = useParams();

    useEffect(()=>{
        window.scrollTo(0,0);
        handleGetModifierOptions();
    },[])

    const redirect = (route) => {
        history.push(route)
    }

    const handleGetModifierOptions = async () => {
        setIsLoading(true);
        const response = await getModifierOptions(modifierGroupId);
        if(response.success === true)
        {
            setModifierGroup(response.data);
            setModifiers(response.data.modifiers);
            console.log('MODIFIERS ===> ',response.data.modifiers);
        }
        
        setIsLoading(false);
    }

    const handleDeleteModifierOption = async (id) => {
        setIsLoading(true);
        const response = await deleteModifierOption(id);
        if(response.success === true)
        {
            //await handleGetAttributes();
            handleGetModifierOptions();
            //setAttributes(prevAttributes => prevAttributes.filter(attribute => attribute.id !== id));
        }
        setIsLoading(false);
    }

    return(
        <Container maxWidth='xl'>
            <CustomBreadcrumbs
                returnTo={`/products/modifiergroups`}
                crumbs={[
                    {name:'Productos',link:'/products'},
                    {name:'Extras',link:'/products/modifiergroups'},
                    {name:'Opciones',link:'/products/modifiergroups/options/'+modifierGroupId}
                ]}
            />
            <br/>
            {/*<SectionTitle title={modifierGroup.name} subtitle={'(Grupo de opciones)'} />*/}
            <SectionTitle title={modifierGroup.name} subtitle={'(Detalle de grupo)'} />
            <Grid container alignItems={'center'} justifyContent={'center'}>
                <Grid item xs={12} lg={8}>
                    <Paper elevation={3} style={{padding:15,backgroundColor:'#ebf9ff'}}>
                        <Grid container alignContent={'center'} justifyContent={'center'}>
                            <Grid item xs={12} lg={2} textAlign={'center'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                                <FontAwesomeIcon icon={faInfoCircle} size='2x' color={theme.palette.link.main}/>
                            </Grid>
                            <Grid item xs={12} lg={10}>
                               
                                <Typography variant="body1" color={theme.palette.text.secondary} gutterBottom>
                                    Añade las opciones individuales para el grupo <span style={{fontWeight:'bold'}}>'{modifierGroup.name}'</span>. Cada una de estas opciones tendrá su propio nombre y precio (si aplica).
                                </Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item xs={12} lg={12} mt={5}>
                    <Button
                        mt={5}
                        variant='contained'
                        endIcon={<AddCircleIcon/>}
                        onClick={()=>redirect(`/products/modifiergroups/options/${modifierGroupId}/create`)}
                    >
                        <Typography>Agregar</Typography>
                    </Button>
                </Grid>
            </Grid>
            

            <Grid container spacing={3} mt={1}>
                <Grid item xs={12}>
                    <ModifierGroupOptionsDataTable 
                        modifiers={modifiers}
                        modifierGroup={modifierGroup.name}
                        onDelete={handleDeleteModifierOption}
                        isLoading={isLoading}
                    />
                </Grid>
            </Grid>

            <QUDProgress open={isLoading}/>
        </Container>
    )
}